export default "__VITE_ASSET__6f9d54a2__"